import { defineRouting } from 'next-intl/routing';

export const routing = defineRouting({
  // A list of all locales that are supported
  /**
   * 현재는 ko만 지원하는 걸로 작업
   */
  locales: ['ko', 'en'],

  // Used when no locale matches
  defaultLocale: 'ko',
});
